module.exports = __webpack_public_path__ + "img/HZMB_RENEW_COMPANY.172800ec.png";